import { logo } from 'assets/images';

export const MainLogo = () => {
  return <img src={logo} alt="logo" width={154} height={58} />;
};
